export default {
  item: [],
  itemList: [],
  groupList: [],
  groupSelected: "all",
  paginationModel: { pageSize: 10, page: 0 },
  inputList: {
    cus_mcg_id: "",
    cus_no: "",
    cus_channel: "",
    cus_firstname: "",
    cus_lastname: "",
    cus_name: "",
    cus_depart: "",
    cus_company: "",
    cus_tel_1: "",
    cus_tel_2: "",
    cus_email: "",
    cus_tax_id: "",
    cus_pro_id: "",
    cus_dis_id: "",
    cus_sub_id: "",
    cus_zip_code: "",
    cus_address: "",
    cus_manage_by: "",
    cus_is_use: true,
    cd_last_datetime: "",
    cd_note: "",
    cd_remark: "",
  },
  mode: "",
  totalCount: 0,
};